module.exports = {
	article: 'A',
	pairedText: 'P',
	articleADay: 'AAD',
	textSet: 'TS'
};
